import { useStaticQuery, graphql } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import Hero from "components/organisms/common/Hero"
import useTranslations from "hooks/useTranslations"
import ImageHeroBackground2 from "components/atoms/schools/ImageHeroBackground2"

const HeroImage = ({ className }) => {
  const data = useStaticQuery(graphql`
    {
      hero: file(relativePath: { eq: "pro/hero.jpg" }) {
        childImageSharp {
          gatsbyImageData(quality: 90)
        }
      }
    }
  `)

  return (
    <GatsbyImage
      loading="eager"
      image={getImage(data.hero)}
      className={className}
      imgStyle={{
        objectFit: "cover",
        objectPosition: "top",
      }}
    />
  )
}

export default function HeroSchool() {
  const { schoolHeroTitle, schoolHeroDescription1, schoolHeroHighlight } =
    useTranslations()
  return (
    <Hero
      Image={ImageHeroBackground2}
      slides={[schoolHeroTitle]}
      description={schoolHeroDescription1}
      bgColor="yellow"
      searchWords={schoolHeroHighlight || [""]}
    />
  )
}
